import { Flex, Text } from '@chakra-ui/react';

const DatanaErpIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" fill="none" width="18px" height="18px">
    <rect width="60" height="60" rx="14" fill="#7C5CFC" />
    <path d="M18 48L30 12H36L24 48H18Z" fill="white" />
    <path d="M24 48L36 12C36 12 50 12 50 30C50 48 36 48 36 48H24Z" fill="white" fillOpacity="0.6" />
    <path d="M18 48L30 12C30 12 16 12 12 30C10 42 18 48 18 48Z" fill="white" fillOpacity="0.6" />
  </svg>
);

const PoweredByDatanaErp = ({ label = 'Powered by' }: { label?: string }) => {
  return (
    <a href="https://www.datanaerp.com/" target="_blank" rel="noopener noreferrer">
      <Flex alignItems="center" gap={1.5} _hover={{ opacity: 0.8 }} transition="opacity 0.15s">
        <Text fontSize="xs" color="text.secondary" whiteSpace="nowrap">
          {label}
        </Text>
        <DatanaErpIcon />
        <Text fontSize="sm" fontWeight="bold" whiteSpace="nowrap">
          Datana
        </Text>
      </Flex>
    </a>
  );
};

export default PoweredByDatanaErp;
